import {createContext} from "react";


export default createContext({
    epoch_last: false,
    ended_before: false,
    epoch_started: false
});